import { nanoid } from 'nanoid';
import { useSearchZustandStore } from '@/helpers/searchctx.js';
import { useTranslation } from '@/helpers/translate';

function NoResults() {
  const { t } = useTranslation();
  function cleanFilter() {
    const {
      hub, title, lat, lng, page, zoom,
    } = useSearchZustandStore.getState().initParams;
    const newInitParams = {
      hub, title, lat, lng, page, zoom,
    };
    useSearchZustandStore.setState({ initParams: { ...newInitParams }, initFilters: nanoid() });
  }

  // WEA-157 : la colonne (position, hauteur, fond) est désormais portée une seule fois par
  // components/search/results.js pour les trois états — ici on ne rend que le message.
  return (
    <div className="flex justify-center items-center px-4 py-16 bg-white lg:h-[calc(100vh-260px)]">
      <div className="text-center">
        <h1 className="mb-4 text-2xl">{t('search:no_result.title')}</h1>
        <p className="max-w-[440px] text-purple-5/50 mb-4">{t('search:no_result.p')}</p>
        <button className="px-4 py-2 purple-gradient" onClick={() => cleanFilter()}>{t('search:no_result.button')}</button>
      </div>
    </div>
  );
}

export default NoResults;
